import { FloatingPanel } from '@mews/b2b-ui';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { Body, Stack, Title } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { GoLiveTaskTable } from '../setupTab/components/goLiveTaskTable/GoLiveTaskTable';

interface AuditLogDetailsDialogProps {
    active: boolean;
    auditLogId: string;
    onClose: () => void;
}
export const AuditLogDetailsDialog = ({ active, auditLogId, onClose }: AuditLogDetailsDialogProps) => {
    const { data, isLoading } = useRepositoryQuery('enterprises', 'getOnboardingAuditLogData', {
        auditLogId,
    });

    return (
        <FloatingPanel size="large" active={active} onClose={onClose} title={data?.title ?? ''} loading={isLoading}>
            <Stack vertical spacing="300">
                {data?.note ? (
                    <Stack vertical spacing="100">
                        <Title level={3}>{lt('Note')}</Title>
                        <Body size="small" variant="secondary">
                            {data?.note}
                        </Body>
                    </Stack>
                ) : null}
                {data?.content ? <GoLiveTaskTable audits={data.content} inDialog /> : null}
            </Stack>
        </FloatingPanel>
    );
};
